import Stack from "@mui/material/Stack"
import AttachFileIcon from "@mui/icons-material/AttachFile"
import { Box, Button, Link as MuiLink, Typography } from "@mui/material"
import FileDownloadIcon from "@mui/icons-material/FileDownload"
import DeleteIcon from "@mui/icons-material/Delete"
import CloudDoneIcon from "@mui/icons-material/CloudDone"

import { useDispatch } from "react-redux/es/hooks/useDispatch"
import { delFiles, removeFile } from "../../../dialogs/model/Interviews"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"

const FilesList = ({ flies, handleFileDownload, handleRemoveFile }: any) => {
  const dispatch = useDispatch()

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const fileUrl = searchParams.get("fileUrl")

  const downloadFile = (fileUrl: string | URL | Request, fileName: string) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
      .catch((error) => {
        console.error("Произошла ошибка при загрузке файла:", error)
      })
  }

  useEffect(() => {
    if (fileUrl) {
      downloadFile(fileUrl, "downloaded_file.png") // Указываем желаемое имя файла
    }
  }, [fileUrl])

  // Пример использования функции

  return (
    <Stack sx={{ overflow: "auto", maxHeight: "178px" }} spacing={"5px"}>
      {flies?.map((file: any, index: number) => (
        <Stack
          key={index}
          sx={{
            bgcolor: "#FFFFFF",
            width: "100%",
            height: "31px",
            borderRadius: "4px",
            px: "10px",
          }}
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Stack alignItems={"center"} direction={"row"} spacing={"5px"}>
            {file.isCloud ? (
              <CloudDoneIcon
                sx={{
                  height: "16px",
                  width: "16px",
                  color: "rgb(27, 156, 24,0.5)",
                }}
              />
            ) : (
              <AttachFileIcon
                sx={{
                  height: "16px",
                  width: "16px",
                  color: "rgb(27, 156, 24,0.5)",
                }}
              />
            )}

            {(file.name.toLowerCase().endsWith(".png") && file.isCloud) ||
            (file.name.toLowerCase().endsWith(".jpeg") && file.isCloud) ? (
              <MuiLink
                target="_blank"
                color="inherit"
                href={file.isCloud ? file.link : undefined}
                sx={{
                  display: "inline-block",
                  position: "relative",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: 14,
                    color: "text.primary",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    maxWidth: "600px",
                  }}
                >
                  {decodeURIComponent(file.name)}
                </Typography>
              </MuiLink>
            ) : (
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: 14,
                  color: "text.primary",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  maxWidth: "600px",
                }}
              >
                {decodeURIComponent(file.name)}
              </Typography>
            )}
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: 14,
                color: "text.secondary",
              }}
            >
              {file.isCloud
                ? ""
                : `${
                    file.size > 1024 * 1024
                      ? (file.size / 1024 / 1024).toFixed(0) + " mb"
                      : (file.size / 1024).toFixed(0) + " kb"
                  }`}
            </Typography>
          </Stack>
          <Stack direction={"row"} spacing={"5px"}>
            {file.isCloud && file.link ? (
              <Button
                sx={{ fontWeight: "bold" }}
                size="small"
                onClick={() => {
                  downloadFile(file.link, decodeURIComponent(file.name))
                }}
                startIcon={<FileDownloadIcon />}
              >
                Скачать
              </Button>
            ) : (
              <></>
            )}

            <Button
              color="error"
              sx={{ fontWeight: "bold" }}
              size="small"
              onClick={() => {
                if (file.isCloud) {
                  dispatch(delFiles([file.link]))
                }
                handleRemoveFile(file)
                dispatch(removeFile(file))
              }}
              startIcon={<DeleteIcon />}
            >
              Удалить
            </Button>
          </Stack>
        </Stack>
      ))}
    </Stack>
  )
}

export default FilesList
